<script>
import DataTable from 'datatables.net-vue3';
export default {
    
    props: {
        SearchData :{
            type : Object,
        }
    },

    data() {
        return {
            totalEstimate:'',
        }},
    methods: {
        

        totalEstimateCalculate(datas) { 
            return datas.reduce((acc, data) => acc + (data.voucher.voucher_value * data.trade_up.quantity), 0); 
        },
    },
    mounted() {
        
    },

    components: {
    DataTable,
  },
}
require("@/assets/css/datatable.css");
</script>
<template>
    <div class="card card-body">
        <div class="card-body">
            <div class="spinner-border text-success" role="status" v-if="LoadingSearch">
                <span class="sr-only">Loading...</span>
            </div>
            <div v-else>
                <div class="table-responsive table-card">

                    <DataTable class="table align-middle table-nowrap">
                        <thead class="table-light text-muted">
                            <tr>
                                <th>NO.</th>
                                <th>TradeIn OrderId</th>
                                <th>Customer Name</th>
                                <th>Customer Contact Number</th>
                                <th>Email</th>
                                <!-- 1 -->
                                <th>Date And Time</th>
                                <th>TradeIn Brand</th>
                                <th>TradeIn Model </th>
                                <!-- 2 -->
                                <th>TradeIn IMEI</th>
                                <th>TradeIn Amount</th>
                                <th>Voucher Amount</th>
                                <th>TradeUp Brand</th>
                                <!-- 3 -->
                                <!-- <th>Pickup Type</th> -->
                                <th>TradeUp Model</th>
                                <th>TradeUp Amount</th>
                                <!-- 4 -->
                                <th>Trade-Up IMEI</th>
                            </tr>
                        </thead>
                        <!--end thead-->
                        <tbody class="list form-check-all">
                            <tr v-for="(data, index) of SearchData" :key="index">
                                <td>{{ index+1 }}</td>

                                <td><router-link :to="'/order/details/'+data.id">{{ data.OrderId }}</router-link></td>
                                <td>{{ data.cus_name }}</td>
                                <td>{{ data.cus_contact }}</td>
                                <td>{{ data.cus_email }}</td>
                                <!-- 1 -->
                                <td>{{ data.created_at }} </td>
                                <td>{{ data.ti_brand }}</td>
                                <td>{{ data.ti_model }}</td>
                                <!-- 2 -->
                                <td>{{ data.ti_imei }}</td>
                                <td>{{ data.ti_price }}</td>
                                <td>{{ data.voucher_value }}</td>
                                <td>{{ data.tu_brand }}</td>
                                <!-- 3 -->
                                <!-- <td>{{ data.picuptype }}</td> -->
                                <td>{{ data.tu_model }}</td>
                                <td>{{ data.tu_value }}</td>
                                <!-- 4 -->
                                <td>{{ data.tu_imei }}</td>
                            </tr>
                        </tbody>
                        <!--end tbody-->
                    </DataTable>
                </div>
            </div>
        </div>
    </div>

</template>